import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ISuppliersStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ISuppliersStatsResponse>,
  IPathBaseParam,
  object
>("stores.suppliers.stats");

export const stats = {
  ...getApis,
};
